import angular from 'angular';

class InventoryController {
  static $inject = [];
}

export const InventoryControllerModule = angular
  .module('acme.view.application.inventory.controllers', [])
  .controller('InventoryController', InventoryController).name;
